export default __webpack_public_path__ + "static/media/admin_image.4583aa6f.png";